import { useEffect, useState } from "react"
import useAuthenticationStore from "src/store/authentication"
import { alpha, Stack, useTheme } from "@mui/material"
import MuiButton from "src/components/common/button"
import ValidationHelperText from "src/components/common/validation-helper-text"
import { useForm } from "react-hook-form"
import { toast } from "react-toastify"
import { useRouter } from "next/router"
import { onlyDigitsWithMaxLen } from "../../../../common/inputs/helper"
import mobileValidation from "../../../../common/inputs/mobileValidation"
import LtrTextField from "src/components/common/inputs/LtrTextField"

// -------------------------------------------|| LOGIN FORM - COMPONENTS || -----------------------------------------

const LoginForm = ({ userData }) => {
  const [state, setState] = useState("loading" | "error" | "done")
  const router = useRouter()
  const theme = useTheme()
  const { doLogin } = useAuthenticationStore()

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm()

  const handleGetDataFromURL = url => {
    const regex = /mobileNumber:(\d+)/
    const match = url?.match(regex)
    if (match) {
      setValue("phoneNumber", match[1])
    } else {
      return
    }
  }
  useEffect(() => {
    handleGetDataFromURL(userData)
  }, [])

  // Handle Login
  const handleLogin = val => {
    setState("loading")
    doLogin(val)
      .then(response => {
        const { status, data } = response
        if (status === 200) {
          setState("done") // Set status 'done'
          if (!data?.hasValue) {
            toast.error(data?.message) // Show Error Message
          } else {
            let redirectRoute = `/verifyLogin?phoneNumber=${val?.phoneNumber}`;
            if (router.query?.backUrl) {
              const raw = Array.isArray(router.query.backUrl)
                ? router.query.backUrl[0]
                : router.query.backUrl;

              redirectRoute += `&backUrl=${encodeURIComponent(raw)}`;
            }
            router.push(redirectRoute)
            toast.success("پیامک ارسال شد.")
          }
        }
      })
      .catch(() => {
        setState("error")
      })
  }

  return (
    <form onSubmit={handleSubmit(handleLogin)}>
      <Stack mt={3}>
        <LtrTextField
          autoFocus={true}
          onKeyDown={onlyDigitsWithMaxLen(11)}
          sx={{
            caretColor: theme.palette.secondary.main,
            "& .MuiInputBase-root": {
              borderRadius: "8px",
              backgroundColor: alpha(theme.palette.grey[200], 0.5)
            }
          }}
          defaultValue={router?.query?.phone ? router.query.phone : ""}
          type='tel'
          pattern='[0-9]{3}-[0-9]{3}-[0-9]{4}'
          fullWidth
          label='شماره موبایل'
          name='phoneNumber'
          {...register("phoneNumber", {
            required: "شماره موبایل اجباری است",
            maxLength: {
              value: 11,
              message: "شماره موبایل باید 11 رقم باشد"
            },
            minLength: {
              value: 11,
              message: "شماره موبایل باید 11 رقم باشد"
            },
            validate: mobileValidation
          })}
          inputProps={{ maxLength: 11 }}
        />
        <ValidationHelperText error={errors?.phoneNumber} helperText={errors?.phoneNumber?.message} />
      </Stack>

      <MuiButton loading={state === "loading"}>دریافت کد</MuiButton>
    </form>
  )
}

export default LoginForm
